/** The standard error envelope's message (`error.message`, §6.10), if the API
 *  sent one — shared by useSaveFlow and useDeleteFlow, so a refused save or
 *  delete shows the server's reason instead of a generic failure. */
export function serverMessage(e: unknown): string | undefined {
  return (e as { response?: { data?: { error?: { message?: string } } } })
    ?.response?.data?.error?.message || undefined;
}
